import React from 'react';
import accounting from 'accounting';
import _ from 'lodash';
import { CURRENCY, CURRENCYCLASSNAME } from '../../../helpers/variables';

const PercentageWizardTableCell = (props) => {
    // Helper to render plain cells
    const renderPlainCell = (value, isCurrency) => (
        <div className='premiumSettingsWizard-table-plain-cell'>
            {isCurrency 
                ? accounting.formatMoney(value, `${CURRENCY} `, 2) 
                : `${_.round(value, 2)}%`}
        </div>
    );

    // Helper to render input cells
    const renderInputCell = ({ value, name, id = '' }) => (
        <div className={props.isNonRecoverable ? CURRENCYCLASSNAME : 'percentInput'}>
            <input
                min={props.isNonRecoverable ? '0.00' : undefined}
                max={props.isNonRecoverable ? undefined : '100.00'}
                value={value === '' ? '' : _.round(value, 2)}
                required={true}
                name={name}
                id={id}
                onChange={(evt) =>
                    props.handlePercentagePremiumTableChange(
                        evt.target.name,
                        evt.target.value,
                        props.realIndex,
                        props.isCommission ? props.solicitorIndex : undefined
                    )
                }
                className='formGroupTableRow-textInput-input col-sm-11'
                type='number'
                step='0.01'
            />
        </div>
    );

    // Determine the value, name, and id based on the type
    const value = props.isNonRecoverable
        ? props.tableData[props.realIndex].nonRecoverable
        : props.isUnderwriter
        ? props.tableData[props.realIndex].underwriterRatePercentage
        : props.tableData[props.realIndex]?.premiumSubSettingCommissions[props.solicitorIndex]?.commissionPercentage;

    const name = props.isNonRecoverable
        ? 'nonRecoverable'
        : props.isUnderwriter
        ? 'underwriterRatePercentage'
        : 'commissionPercentage';

    const id = props.isCommission ? `sol${props.realIndex}${props.solicitorIndex}commissionPercentage` : '';

    // Determine the table cell class
    const tdClassName = props.isNonRecoverable
        ? 'premiumSettingsWizard-table-data premiumSettingsWizard-table-data-ammount-column-text'
        : 'premiumSettingsWizard-table-data premiumSettingsWizard-table-data-percentage-column-text';

    // Render the cell
    return (
        <td key={props.realIndex} className={tdClassName}>
            {props.isPlain
                ? renderPlainCell(value, props.isNonRecoverable)
                : renderInputCell({ value, name, id })}
        </td>
    );
};

export default PercentageWizardTableCell;
